(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["waykeeper-cinematic"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.waykeeperMotion) return;
  window.waykeeperMotion = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 1000px) and (pointer: fine)');
  const seen = new WeakSet();
  const drifting = new Set();
  const active = new Set();
  let frame = 0;
  const reveal = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal.unobserve(entry.target);
      if (reduced.matches || window.Shopify?.designMode) return;
      const media = entry.target.dataset.wkReveal === 'media';
      if (media && !desktop.matches) return;
      const keys = media
        ? [{ clipPath: 'inset(4% 3% 4% 3%)' }, { clipPath: 'inset(0% 0% 0% 0%)' }]
        : [{ opacity: .3, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }];
      entry.target.animate(keys, { duration: desktop.matches ? 750 : 420, easing: 'cubic-bezier(.16,1,.3,1)' });
    });
  }, { threshold: .04, rootMargin: '0px 0px 60px 0px' });
  const viewport = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) active.add(entry.target); else active.delete(entry.target);
      const video = entry.target.querySelector('video');
      if (video) {
        if (entry.isIntersecting && !reduced.matches) { video.muted = true; video.play().catch(() => {}); }
        else video.pause();
      }
    });
    schedule();
  }, { rootMargin: '120px' });
  function paint() {
    frame = 0;
    if (reduced.matches || !desktop.matches || window.Shopify?.designMode) return;
    active.forEach(story => {
      if (!story.isConnected) { active.delete(story); drifting.delete(story); return; }
      if (!drifting.has(story)) return;
      const rect = story.getBoundingClientRect();
      const travel = Math.min(22, Math.max(-22, (innerHeight / 2 - rect.top - rect.height / 2) * .045));
      story.style.setProperty('--wk-drift', `${travel.toFixed(2)}px`);
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(paint); }
  function init(scope = document) {
    scope.querySelectorAll('[data-wk-reveal], .wk-home .section-header, .wk-home .section-stack__intro, .wk-home .newsletter-content').forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (!el.closest('[data-motion="false"]')) reveal.observe(el);
    });
    scope.querySelectorAll('[data-wk-story]').forEach(story => {
      if (story.dataset.motion === 'true') drifting.add(story);
      viewport.observe(story);
    });
    schedule();
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-wk-story]').forEach(story => {
      viewport.unobserve(story); active.delete(story); drifting.delete(story);
    });
  });
  reduced.addEventListener('change', () => {
    document.querySelectorAll('[data-wk-story]').forEach(story => {
      story.style.removeProperty('--wk-drift');
      const video = story.querySelector('video');
      if (video && reduced.matches) video.pause();
    });
    schedule();
  });
  desktop.addEventListener('change', () => {
    if (!desktop.matches) drifting.forEach(story => story.style.removeProperty('--wk-drift'));
    schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
